var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 32,
    width: 170,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 32H11V159.325H181V32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.724 124.346H52.2759V159.325H139.724V124.346Z",
    fill: "#2FD8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7243 159.325C78.8725 159.325 98.4486 139.749 98.4486 115.601C98.4486 91.4526 78.8725 71.8765 54.7243 71.8765C30.576 71.8765 11 91.4526 11 115.601C11 139.749 30.576 159.325 54.7243 159.325Z",
    fill: "#385DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0002 119.449C120.148 119.449 139.724 99.8725 139.724 75.7243C139.724 51.576 120.148 32 96.0002 32C71.8519 32 52.2759 51.576 52.2759 75.7243C52.2759 99.8725 71.8519 119.449 96.0002 119.449Z",
    fill: "#358DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.276 159.325C161.424 159.325 181 139.749 181 115.601C181 91.4526 161.424 71.8765 137.276 71.8765C113.127 71.8765 93.5513 91.4526 93.5513 115.601C93.5513 139.749 113.127 159.325 137.276 159.325Z",
    fill: "#2FD8C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05da997300354fa3ed93c0d245268f22.svg";
export { ForwardRef as ReactComponent };